import { Checkbox, Switch, Tag } from "antd";
import AnimatedDatePicker from "components/AnimatedDatePicker";
import AnimatedCustomSelect from "components/AnimatedSelectComp";
import AnimatedTextField from "components/AnimatedTextField";
import moment from "moment";
import React, { useEffect, useState } from "react";
const XMark = require('Assets/common/Xmark.svg').default;
function CreateOfferApplicable({ offersObj,
    setOffersObjKey,
    inputStyle,
    cardClassName,
    storeAutocompleteSearchData,
    getAutocompleteSearchOffers,
    getCoursesCategories,
    getCoursesSubCategories,
    courseCategoryData,
    courseSubCategoriesData,
    autocompleteSearchData,
    selectedCategories,
    setSelectedCategories,
    selectedSubcategories,
    setSelectedSubcategories,
    selectedCourse,
    setSelectedCourse,
    setOffersObj,
    courseDetails,
    hasOfferDate,
    setHasOfferDate,
    setFormHasOfferDate,
    hasPromo,
    setHasPromo,
    hidePrivate,
    setFormHasPromo,
    sizeOfContents
}) {
    const [categoryListToShow, setCategoryListToShow] = useState([]);
    const [subCategoryListToShow, setSubCategoryListToShow] = useState([]);
    const [searchName, setSearchName] = useState(null);

    let offerTypesArray = [
        { id: "course", value: "Course type" },
        { id: "category", value: "Course category" },
        { id: "subcategory", value: "Course subcategory" },
        { id: "courseList", value: "Course" },
        { id: "All", value: 'All' }
    ];


    const getOffersValue = (type) => {
        if (type == 'liveCourse' || type == 'videoResource' || type == 'studyMaterial' || type == 'testSeries') {
            return 'A course'
        } else {
            return offerTypesArray.find((item) => item.id == type)?.value || null;
        }
    }
    function checkApplicableAll(live, video, study, testSeries) {
        if (live && video && study && testSeries) {
            setOffersObjKey('type', 'All');
        }
    }
    const getCategoryOptions = () => {
        let options = categoryListToShow;
        if (selectedCategories?.length) {
            options = options.filter((item) => !selectedCategories.some((ele) => ele.id == item.id));
        }
        if (searchName) {
            options = options.filter((item) => item.name.toLowerCase().includes(searchName.toLowerCase()))
        }
        return options;
    }
    const getCourseOptions = () => {
        let options = autocompleteSearchData;
        if (selectedCourse?.length) {
            options = options.filter((item) => !selectedCourse.some((ele) => ele.itemId == item.itemId && ele.itemType == item.itemType));
        }
        if (searchName) {
            options = options.filter((item) => item.name.toLowerCase().includes(searchName.toLowerCase()))
        }
        return options;
    }
    useEffect(() => {
        storeAutocompleteSearchData([])
        if (offersObj?.type == "category") {
            getCoursesCategories(() => { updateCategoriesList() })
        } else if (offersObj?.type == "subcategory") {
            getCoursesSubCategories(null, () => { updateSubcategoriesList() })
        } else if (offersObj?.type == "courseList") {
            getAutocompleteSearchOffers(null, null, true)
        }
    }, [offersObj?.type])

    const updateCategoriesList = () => {
        setCategoryListToShow(courseCategoryData?.map(item => Object.assign(item, { key: item.id, label: item.name, value: item.id })))
    }

    const updateSubcategoriesList = () => {
        setSubCategoryListToShow(courseSubCategoriesData?.map(item => Object.assign(item, { key: item.id, label: item.name, value: item.id })))
    }


    const handleCategorySelect = (value, obj) => {
        if (!selectedCategories?.some((item) => item.id == obj.id)) {
            setSelectedCategories((selectedCategories) => [...selectedCategories, obj]);
            setOffersObjKey('categoryIds', offersObj?.categoryIds?.length ? [...offersObj.categoryIds, obj.id] : [obj.id]);
        }
        setSearchName('');
    }

    const handleSubcategorySelect = (value, obj) => {
        if (!selectedSubcategories?.some((item) => item.id == obj.id)) {
            setSelectedSubcategories((selectedSubcategories) => [...selectedSubcategories, obj]);
            setOffersObjKey('subcategoryIds', offersObj?.subcategoryIds?.length ? [...offersObj.subcategoryIds, obj.id] : [obj.id]);
        }
        setSearchName('');
    }

    const disabledStartDate = (current) => {
        const today = moment();
        return current && current < today.startOf('day');
    };
    const disabledEndDate = (current) => {
        const today = moment().format('YYYY-MM-DD');
        const currentDate = current.format('YYYY-MM-DD');
        return current && (currentDate < today || (offersObj?.startDate && currentDate < moment(offersObj.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')));
    };

    const handleCourseAutoCompleteSearch = (value) => {
        getAutocompleteSearchOffers(value);
    }
    const handleCourseSelect = (value, obj) => {
        if (!selectedCourse?.map(item => item.id)?.includes(obj.key - 1)) {
            const newCourse = autocompleteSearchData?.[obj.key - 1];
            if (newCourse) {
                setSelectedCourse((cItem) => {
                    const newItems = (cItem || []).concat([
                        {
                            id: newCourse.id - 1,
                            name: newCourse.name,
                            itemId: newCourse.itemId,
                            itemType: newCourse.itemType,
                            value: newCourse.name,
                            label: newCourse.name,
                        }
                    ]);
                    setOffersObjKey('courseItems', newItems);
                    return newItems;
                });
            }
            setSearchName('')
        }
    }
    const handleSearchCategory = (query) => {
        if (query != null) {
            setSearchName(query);
        }
    }

    const handleSearchSubcategory = (query) => {
        if (query != null) {
            setSearchName(query);
        }
    }

    const handleCategoryTagClose = (id) => {
        setSelectedCategories((selectedCategories) => selectedCategories.filter((item) => item.id != id));
        setOffersObjKey('categoryIds', (offersObj?.categoryIds || []).filter((item) => item.id != id));
    }

    const handleCourseTagClose = (itemType, itemId) => {
        if (courseDetails) {
            return;
        }
        setSelectedCourse((selectedCourse) => selectedCourse.filter((item) => !(item.itemId == itemId && item.itemType == itemType)));
    }

    const handleSubcategoryTagClose = (id) => {
        setSelectedSubcategories((selectedSubcategories) => selectedSubcategories.filter((item) => item.id != id));
        setOffersObjKey('subcategoryIds', (offersObj?.subcategoryIds || []).filter((item) => item.id != id));
    }

    const getSubcategoryOptions = () => {
        let options = subCategoryListToShow;
        if (selectedSubcategories?.length) {
            options = options.filter((item) => !selectedSubcategories.some((ele) => ele.id == item.id));
        }
        if (searchName) {
            options = options.filter((item) => item.name.toLowerCase().includes(searchName.toLowerCase()))
        }
        return options;
    }
    return (
        <div className={cardClassName} style={{ marginBottom: 10, color: "#636363" }}>
            <div style={{ color: "#636363", fontSize: 18, fontWeight: 700 }}>Offer applicability</div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
                <div style={{ fontSize: 14, color: "#636363" }}>User need to enter promo code to avail this promotional offer</div>
                <Switch checked={hasPromo} onChange={() => {
                    setHasPromo(!hasPromo);
                    if (setFormHasPromo) {
                        setFormHasPromo(!hasPromo);
                    }
                    setOffersObjKey('code', '');
                }} />
            </div>
            {hasPromo ?
                <>
                    <AnimatedTextField
                        label={"Promo code (5 to 20 characters)"}
                        isMandatory={true}
                        inputId={"-1004"}
                        value={offersObj?.code || ''}
                        handleInputChange={(e) => {
                            setOffersObjKey("code", e.target.value?.replaceAll(' ', '')?.slice(0, 20) || '')
                        }}
                        style={{ marginTop: 30 }}
                        inputstyle={inputStyle}
                    />
                    {!hidePrivate ? (
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
                                <div style={{ fontSize: 14, color: "#636363" }}>This promo code is private</div>
                                <Switch checked={offersObj?.privateOffer} onChange={() => {
                                    if (!offersObj?.privateOffer) {
                                        setHasOfferDate(false);
                                        if (setFormHasOfferDate) {
                                            setFormHasOfferDate(false);
                                        }
                                        setOffersObj({
                                            ...offersObj, type: 'course', applicableLive: true, applicableVideo: true,
                                            applicableStudy: true, applicableTest: true, privateOffer: true, startDate: null, endDate: null, maxUses: 0,
                                        })
                                    } else {
                                        const {
                                            type,
                                            applicableLive,
                                            applicableVideo,
                                            applicableStudy,
                                            applicableTest,
                                            startDate,
                                            endDate,
                                            maxUses,
                                            ...others } = offersObj;
                                        setOffersObj({
                                            ...others,
                                        })
                                        setOffersObjKey('privateOffer', !offersObj?.privateOffer)
                                    }
                                }} />
                            </div>
                            {offersObj?.privateOffer ?
                                (
                                    <div className='r-c-fs' style={{ gap: "2rem", alignItems: 'flex-end' }}>
                                        <AnimatedTextField
                                            label={"Enter number of usage"}
                                            isMandatory={true}
                                            inputId={"-1006"}
                                            value={offersObj?.maxUses || null}
                                            handleInputChange={(e) => {
                                                let enteredValue = parseInt(e.target.value) || 0;
                                                enteredValue = enteredValue < 0 ? 0 : enteredValue;
                                                setOffersObjKey("maxUses", enteredValue)
                                            }}
                                            style={{ marginTop: 30, width: "50%" }}
                                            inputstyle={inputStyle}
                                        // //type="number"
                                        />
                                        <div style={{ width: "50%" }}>
                                            <AnimatedDatePicker
                                                label="Valid till"
                                                allowClear={true}
                                                style={{ marginLeft: "-10px", pointetEvents: 'none', color: '#AEAEAE' }}
                                                value={offersObj?.endDate ? moment(offersObj.endDate, 'DD/MM/YYYY') : null}
                                                format={'DD/MM/YYYY'}
                                                disabledDate={disabledEndDate}
                                                handleDateChange={(date, dateString) => { setOffersObjKey('endDate', dateString) }}
                                                inputId={"-1081"}
                                                borderStyle={{ borderBottom: '1px solid #E0E0E0' }}
                                            />
                                        </div>
                                    </div>
                                )
                                : null
                            }
                        </>
                    )
                        : null
                    }
                </>
                : null}
            {!offersObj?.privateOffer ? (
                <>
                    <div className='offer-applicable-selector'>
                        <AnimatedCustomSelect
                            label={"Promotional offer applicable for"}
                            required={true}
                            options={offerTypesArray}
                            value={courseDetails ? 'courseList' : getOffersValue(offersObj?.type)}
                            disabled={!!courseDetails}
                            isSelected={getOffersValue(offersObj?.type) ? true : false}
                            handleSelectChange={(value) => {
                                setOffersObjKey("type", value);
                                if (value == 'course') {
                                    setOffersObjKey("applicableLive", false);
                                    setOffersObjKey("applicableVideo", false);
                                    setOffersObjKey("applicableStudy", false);
                                    setOffersObjKey("applicableTest", false);
                                }
                            }}
                            style={{ marginTop: "1rem", cursor: 'pointer !important' }}
                        />
                    </div>
                    {offersObj?.type === 'course'
                        ? <div className='r-c-fs' style={{ gap: '3rem', fontSize: 14 }}>
                            <div className='r-c-c' style={{ gap: '1rem' }}>
                                <Checkbox
                                    checked={offersObj?.type == 'course' && offersObj?.applicableLive}
                                    //style={{ marginRight: 10 }}
                                    onChange={(e) => {
                                        setOffersObjKey('applicableLive', !offersObj?.applicableLive);
                                        checkApplicableAll(!offersObj?.applicableLive, offersObj?.applicableVideo, offersObj?.applicableStudy, offersObj?.applicableTest);
                                    }} />
                                <span style={{ color: "#636363" }}>Live courses</span>
                            </div>

                            {
                                sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0
                                    ?
                                    <></>
                                    :
                                    <div className='r-c-c' style={{ gap: '1rem', }}>
                                        <Checkbox
                                            checked={offersObj?.type == 'course' && offersObj?.applicableVideo}
                                            //style={{ marginRight: 10 }}
                                            onChange={(e) => {
                                                setOffersObjKey('applicableVideo', !offersObj?.applicableVideo);
                                                checkApplicableAll(offersObj?.applicableLive, !offersObj?.applicableVideo, offersObj?.applicableStudy, offersObj?.applicableTest);
                                            }} />
                                        <span style={{ color: "#636363" }}>Video courses</span>
                                    </div>

                            }

                            {
                                sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0
                                    ?
                                    <></>
                                    :

                                    <div className='r-c-c' style={{ gap: '1rem' }}>
                                        <Checkbox
                                            checked={offersObj?.type == 'course' && offersObj?.applicableTest}
                                            //style={{ marginRight: 10 }}
                                            onChange={(e) => {
                                                setOffersObjKey('applicableTest', !offersObj?.applicableTest);
                                                checkApplicableAll(offersObj?.applicableLive, offersObj?.applicableVideo, offersObj?.applicableStudy, !offersObj?.applicableTest);
                                            }} />
                                        <span style={{ color: "#636363" }}>Online test series</span>
                                    </div>

                            }

                            {
                                sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0
                                    ?
                                    <></>
                                    :
                                    <div className='r-c-c' style={{ gap: '1rem' }}>
                                        <Checkbox
                                            checked={offersObj?.type == 'course' && offersObj?.applicableStudy}
                                            //style={{ marginRight: 10 }}
                                            onChange={(e) => {
                                                setOffersObjKey('applicableStudy', !offersObj?.applicableStudy);
                                                checkApplicableAll(offersObj?.applicableLive, offersObj?.applicableVideo, !offersObj?.applicableStudy, offersObj?.applicableTest);
                                            }} />
                                        <span style={{ color: "#636363" }}>Study materials</span>
                                    </div>
                            }



                        </div>
                        : null
                    }
                    {offersObj?.type === 'category'
                        ? <div>
                            <AnimatedCustomSelect
                                label={"Select course categories"}
                                required={true}
                                options={getCategoryOptions()}
                                value={searchName}
                                isSelected={searchName ? true : false}
                                handleSelectChange={e => { setSearchName(e) }}
                                handleSelectOnSelect={(value, obj) => handleCategorySelect(value, obj)}
                                handleSelectOnSearch={(query) => { setSearchName(query); handleSearchCategory(query) }}
                                showSearch={true}
                                allowClear={searchName ? true : false}
                                onClear={() => setSearchName('')}
                                style={{ marginBottom: 0 }}
                                autoFocus={true}
                            />
                            <div className="flex-wrap m-t-10">
                                {selectedCategories?.map((category) =>
                                    <Tag
                                        key={category.id}
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            color: '#191919',
                                            padding: "5px 10px",
                                            borderRadius: 20,
                                            border: "1px solid #D7D7D7",
                                            fontSize: 14,
                                            color: "#636363",
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            justifyContent: 'center',
                                            width: 'fit-content',
                                            marginBottom: '10px',
                                        }}
                                        closeIcon={<img src={XMark} alt="custom icon" style={{ width: 10, height: 10, marginLeft: '5px', color: '#636363' }} />}
                                        closable
                                        onClose={() => handleCategoryTagClose(category.id)}
                                        onClick={() => handleCategoryTagClose(category.id)}
                                    >
                                        {category?.value}
                                    </Tag>
                                )}
                            </div>
                        </div>
                        : null
                    }
                    {offersObj?.type === 'subcategory'
                        ? <div>
                            <AnimatedCustomSelect
                                label={"Select course subcategories"}
                                required={true}
                                options={getSubcategoryOptions()}
                                value={searchName}
                                isSelected={searchName ? true : false}
                                handleSelectChange={e => { setSearchName(e) }}
                                handleSelectOnSelect={(value, obj) => handleSubcategorySelect(value, obj)}
                                handleSelectOnSearch={(query) => { setSearchName(query); handleSearchSubcategory(query) }}
                                showSearch={true}
                                allowClear={searchName ? true : false}
                                onClear={() => setSearchName('')}
                                style={{ marginBottom: 0 }}
                                autoFocus={true}
                            />
                            <div className="flex-wrap m-t-10">
                                {selectedSubcategories?.map((category) =>
                                    <Tag
                                        key={category.id}
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            color: '#191919',
                                            padding: "5px 10px",
                                            borderRadius: 20,
                                            border: "1px solid #D7D7D7",
                                            fontSize: 14,
                                            color: "#636363",
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            justifyContent: 'center',
                                            width: 'fit-content',
                                        }}
                                        closable
                                        closeIcon={<img src={XMark} alt="custom icon" style={{ width: 10, height: 10, marginLeft: '5px', color: '#636363' }} />}
                                        onClose={() => handleSubcategoryTagClose(category.id)}
                                        onClick={() => handleCategoryTagClose(category.id)}
                                    >
                                        {category?.value}
                                    </Tag>
                                )}
                            </div>
                        </div>
                        : null
                    }
                    {courseDetails || offersObj?.type === 'courseList'
                        ? <div>
                            <AnimatedCustomSelect
                                label={"Select course"}
                                required={true}
                                options={getCourseOptions()}
                                value={searchName}
                                isSelected={searchName ? true : false}
                                showSearch={true}
                                handleSelectChange={e => { setSearchName(e) }}
                                onClear={() => { setSearchName(''); setSelectedCourse([]) }}
                                disabled={!!courseDetails}
                                handleSelectOnSelect={(value, option) => handleCourseSelect(value, option)}
                                handleSelectOnSearch={(query) => { setSearchName(query); handleCourseAutoCompleteSearch(query); }}
                                allowClear={searchName || selectedCourse?.[0]?.name ? true : false}
                                style={{ marginBottom: 0 }}
                                autoFocus={true}
                            />
                            <div className="flex-wrap m-t-10">
                                {selectedCourse?.map((course) =>
                                    <Tag
                                        key={course.id}
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            color: '#191919',
                                            padding: "5px 10px",
                                            borderRadius: 20,
                                            border: "1px solid #D7D7D7",
                                            fontSize: 14,
                                            color: "#636363",
                                            cursor: courseDetails ? 'not-allowed' : 'pointer',
                                            display: 'inline-flex',
                                            justifyContent: 'center',
                                            width: 'fit-content',
                                            marginBottom: '10px',
                                        }}
                                        closeIcon={<img src={XMark} alt="custom icon" style={{ width: 10, height: 10, marginLeft: '5px', color: '#636363' }} />}
                                        closable={courseDetails ? false : true}
                                        onClose={() => handleCourseTagClose(course.itemType, course.itemId)}
                                        onClick={() => handleCourseTagClose(course.itemType, course.itemId)}
                                    >
                                        {course?.label}
                                    </Tag>
                                )}
                            </div>
                        </div>
                        : null
                    }
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
                        <div style={{ fontSize: 14, color: "#636363" }}>Add validity</div>
                        <Switch checked={hasOfferDate} onChange={() => {
                            setHasOfferDate((item) => {
                                if (item) {
                                    setOffersObjKey('startDate', null);
                                    setOffersObjKey('endDate', null);
                                }
                                if (setFormHasOfferDate) {
                                    setFormHasOfferDate(!item);
                                }
                                return !item;
                            });
                        }} />
                    </div>
                    {hasOfferDate
                        ? <div className='r-c-fs' style={{ gap: "2rem", marginTop: "0.5rem" }}>
                            <div style={{ width: "50%" }}>
                                <AnimatedDatePicker
                                    bordered={null}
                                    allowClear={true}
                                    placeholder={"Select start date"}
                                    style={{ color: '#AEAEAE' }}
                                    label="Start date"
                                    isMandatory={true}
                                    value={offersObj?.startDate ? moment(offersObj?.startDate, 'DD/MM/YYYY') : null}
                                    format={'DD/MM/YYYY'}
                                    disabledDate={disabledStartDate}
                                    handleDateChange={(date, dateString) => { setOffersObjKey('startDate', dateString); setOffersObjKey('endDate', null); }}
                                    inputId={"-999"}
                                    inputstyle={{
                                        ...(inputStyle || null),
                                        color: "#636363 !important"
                                    }}
                                    borderStyle={{ borderBottom: '1px solid #E0E0E0' }}
                                />
                            </div>
                            <div style={{ width: "50%" }}>
                                <AnimatedDatePicker
                                    label="End date"
                                    allowClear={true}
                                    isMandatory={true}
                                    style={{ marginLeft: "-10px", color: '#AEAEAE' }}
                                    value={offersObj?.endDate ? moment(offersObj?.endDate, 'DD/MM/YYYY') : null}
                                    format={'DD/MM/YYYY'}
                                    disabledDate={disabledEndDate}
                                    handleDateChange={(date, dateString) => { setOffersObjKey('endDate', dateString) }}
                                    inputId={"-998"}
                                    inputstyle={{
                                        ...(inputStyle || null),
                                        color: "#636363 !important"
                                    }}
                                    borderStyle={{ borderBottom: '1px solid #E0E0E0' }}
                                />
                            </div>
                        </div>
                        : null}
                </>)
                : null
            }
        </div>
    );
}
export default CreateOfferApplicable;